const URLS3 = `${process.env.REACT_APP_URL_BUCKET}/public/`
export default URLS3